// extracted by css-extract-rspack-plugin
export default {"errorIcon":"ListError-module__errorIcon__N7fG1","errorMessage":"ListError-module__errorMessage__R9KTd","retryLink":"ListError-module__retryLink__PbBKQ"};